export default {
  // 页面标题和描述
  title: "One Marketer + AI = 500+ Creator Collabs/Month",
  description: "Create your account and discover, connect, and collaborate with the creators who are the perfect fit for your brand.",
  
  referralSource: {
    label: "How did you hear about AhaCreator?",
    placeholder: "Please select how you heard about us",
    otherLabel: "Other channel",
    otherPlaceholder: "Please enter how you heard about us",
    otherRequired: "Please enter how you heard about us",
    required: "Please select how you heard about us",
    options: {
      tiktok: "TikTok",
      instagram: "Instagram",
      youtube: "YouTube",
      twitter_x: "Twitter / X",
      linkedin: "LinkedIn",
      google_search: "Google Search",
      xiaohongshu: "Xiaohongshu",
      wechat_official_account: "WeChat Official Account",
      wechat_moments: "WeChat Moments",
      wechat_channels: "WeChat Channels",
      douyin: "Douyin",
      friend_referral: "Recommended by a friend",
      sales_contact: "Contacted by our sales team",
      other: "Others",
    },
  },
  // 表单字段标签
  formLabels: {
    name: "Name",
    firstName: "First name",
    lastName: "Last name",
    email: "Email (work email recommended)",
    website: "Company website or product",
    budget: "What's your monthly influencer marketing budget",
    industry: "What's your industry",
    goal: "What's your campaign goal",
    location: "Where are you located?",
    organizationLocation: "Where is your organization located?",
    phone: "Phone number",
    wechat: "WeChat",
    contact: "Contact information",
    linkedin: "LinkedIn",
    note: "Anything that will help prepare for our meeting (optional)"
  },
  
  // 表单占位符
  placeholders: {
    name: "Enter your full name",
    firstName: "Enter your first name",
    lastName: "Enter your last name",
    email: "e.g. alex.johnson@company.com",
    website: "e.g. www.yourcompany.com (preferred), product URL, or product name",
    budget: "Select a budget range",
    industry: "Select your industry",
    goal: "Select a campaign goal",
    country: "Select your country or region",
    phone: "Enter your phone number",
    code: "Code",
    wechat: "Enter your WeChat account",
    contact: "LinkedIn / WhatsApp / Line / Telegram / Slack",
    linkedin: "Enter your LinkedIn Profile URL",
    note: "Anything you'd like us to know…"
  },

  // 表单提示
  hints: {
    website:
      "Please enter your company website if available. If you don't have one, you can provide a product page URL (e.g. Amazon) or simply enter your product name.",
  },
  
  // 表单验证消息
  validation: {
    nameRequired: "Please input your name",
    firstNameRequired: "Please input your first name",
    lastNameRequired: "Please input your last name",
    emailRequired: "Please input your work email",
    emailInvalid: "Please input a valid work email",
    websiteRequired: "Please input your company website",
    websiteInvalid: "Please enter a valid website URL",
    budgetRequired: "Please select your marketing budget",
    budgetTooLow: "AhaCreator is designed for budgets of USD 2,000 or more. We'll reach out as soon as AhaCreator Lite supports smaller budgets.",
    industryRequired: "Please input your first name",
    goalRequired: "Please input your last name",
    countryRequired: "Please select Your Country or Region",
    phoneRequired: "Please enter your phone number",
    phoneInvalid: "Invalid phone number",
    phoneMustStartWithPlus: "Phone number must start with +",
    phoneInvalidFormat: "Invalid phone number format",
    phoneCountryCodeMismatch:
      "Phone number must start with {countryCode} for {region}",
    phoneCountryFormatInvalid:
      "Invalid {region} phone number format. Example: {example}",
    codeRequired: "Please enter verification code",
    codeLength: "Verification code must be 6 digits",
    codeIncorrect: "Please enter the correct verification code",
    wechatRequired: "Please enter your WeChat account",
    contactRequired: "Please enter your contact information"
  },
  
  // 按钮文本
  buttons: {
    sendCode: "Send verification code",
    resend: "Resend",
    resendCountdown: "Resend {countdown}s",
    submit: "Submit",
    chooseDateTime: "Choose a date & time",
    loading: "loading...",
    continue: "Continue",
  },
  
  // 其他文本
  required: "*",
  source: "platform",
  
  // 预算选项
  budgetOptions: {
    lessThan2000: "Less than 2,000 USD / mo",
    "2000To10000": "2,000 - 10,000 USD / mo",
    "10000To50000": "10,000 - 50,000 USD / mo",
    moreThan50000: "More than 50,000 USD / mo"
  },
  
  // 行业选项
  industryOptions: {
    aiSaaSApp: "AI / SaaS / App",
    ecommerce: "Ecommerce",
    agency: "Agency – AI/SaaS/App/Ecommerce focus",
    beauty: "Beauty",
    foodBeverage: "Food & beverage",
    others: "Others"
  },
  
  // 活动目标选项
  campaignGoalOptions: {
    brandAwareness: "Brand awareness",
    brandAwarenessAndPerformance: "Brand awareness and performance",
    performanceOnly: "Direct Sales (Not applicable for AhaCreator)"
  }
};
